import { defineMessages } from 'react-intl';

export default defineMessages({
  claimNumber: {
    id: 'manager_home_page.last_assigned_claims_table_fields.claim_number',
  },
  policyNumber: {
    id: 'manager_home_page.last_assigned_claims_table_fields.policy_number',
  },
  claimNature: {
    id: 'manager_home_page.last_assigned_claims_table_fields.claim_nature',
  },
  lossDate: {
    id: 'manager_home_page.last_assigned_claims_table_fields.loss_date',
  },
  registrationNumber: {
    id:
      'manager_home_page.last_assigned_claims_table_fields.registration_number',
  },
  assignedLawyer: {
    id: 'manager_home_page.last_assigned_claims_table_fields.assigned_lawyer',
  },
  assignedCourtManager: {
    id:
      'manager_home_page.last_assigned_claims_table_fields.assigned_court_manager',
  },
  claimNatureCorporeal: {
    id:
      'manager_home_page.last_assigned_claims_table_column.claim_nature.default_value',
  },
  summary: {
    id: 'court_manager_page.summary_button.text',
  },
  tableTitle: {
    id: 'court_manager_page.assigned_claims_table.title',
  },
  basicManagement: {
    id: 'court_manager_page.basic_management_button.text',
  },
  status: {
    id: 'manager_home_page.last_assigned_claims_table_fields.status',
  },
  bawabaStatus: {
    id: 'manager_home_page.last_assigned_claims_table_fields.bawaba_status',
  },
  sagisStatus: {
    id: 'manager_home_page.last_assigned_claims_table_fields.sagis_status',
  },
  validated: {
    id: 'lawyer_assignments_page.assigned_claims_table.claim.status_validated',
  },
  pending: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_pending',
  },
  rejected: {
    id:
      'lawyer_assignments_page.assigned_claims_table.claim.status.status_rejected',
  },
  pendingInfoClaim: {
    id:
      'lawyer_assignments_page.assigned_claims_table.status_pending_info_claim',
  },
  claimType: {
    id: 'manager_home_page.last_assigned_claims_table_fields.type',
  },
  basicManagementTitle: {
    id: 'basic_management.top_card.title',
  },
  validatedCorpo: {
    id: 'manager_recap_page_validated.title',
  },
});
